export const REQUIRED_FIELD_MSG = 'This field is required';
export const requiredFieldValidator = (value: string) => !value ? REQUIRED_FIELD_MSG : '';
